import type { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { actionHelpers, resourceSagaUtils, resourceStoreTypes } from '../core';
import type { QcsSyncResourcesConfig, QcsSyncResourcesConfigProps } from '../core/resourceStoreTypes';
import type { JobStatusProps } from './jobStatusActions';
import * as actions from './jobStatusActions';

const mkQcsSyncJobStatusConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<JobStatusProps>();

type JobStatusResourceConfigProps = Pick<
  QcsSyncResourcesConfigProps<JobStatusProps>,
  'successAction' | 'failureAction'
>;

const mkResourceConfig = (props: JobStatusResourceConfigProps): QcsSyncResourcesConfig<JobStatusProps> =>
  mkQcsSyncJobStatusConfig({
    resourceName: 'job statues',
    resourceBaseUrl: '/job-statuses',
    ignoreError: true,
    handleRetry: false,
    ...props,
  });

export function* deleteJobStatus(
  config: QcsSyncResourcesConfig<JobStatusProps>,
  action: ReturnType<typeof actions.deleteJobStatus>,
): SagaIterator {
  const { id } = action.payload;
  if (id) {
    yield call(resourceSagaUtils.qcsSyncDeleteResource<JobStatusProps>, config, action);
  } else {
    // if we don't have ID (then create on QCS probably failed) - still show success since nothing to really delete
    yield put(config.successAction!(null, actionHelpers.cpMetaForResponseAction({ ...action.meta })));
  }
}

function* createJobStatusActionWatcher(): SagaIterator {
  const resourceConfig = mkResourceConfig({
    successAction: actions.createJobStatusSuccess,
    failureAction: actions.createJobStatusFailure,
  });
  yield takeEvery(
    actions.createJobStatus.type,
    resourceSagaUtils.qcsSyncCreateResource<JobStatusProps>,
    resourceConfig,
  );
}

function* deleteJobStatusActionWatcher(): SagaIterator {
  const resourceConfig = mkResourceConfig({
    successAction: actions.deleteJobStatusSuccess,
    failureAction: actions.deleteJobStatusFailure,
  });
  yield takeEvery(actions.deleteJobStatus.type, deleteJobStatus, resourceConfig);
}

export default [createJobStatusActionWatcher, deleteJobStatusActionWatcher];
